<template>
  <div class="risk-item" :data-sprite-id="info.id">
    <div class="figure">
      <svg
        v-if="specialType === 'artword'"
        style="height: 80%"
        data-name="图层 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 29.95 24.53"
      >
        <path
          fill="#3058FE"
          class="cls-1"
          d="M28.43,21.64H26.07c0,.06,0,.13,0,.19v5.7a1.57,1.57,0,1,1-3.14,0v-5.7a1.23,1.23,0,0,1,0-.19H20.59a1.58,1.58,0,0,1,0-3.15h7.84a1.58,1.58,0,0,1,0,3.15Z"
          transform="translate(-0.05 -5.46)"
        />
        <path
          fill="#3058FE"
          class="cls-2"
          d="M21,12.32H15.59V26.55a3.4,3.4,0,1,1-6.79,0V12.32H3.44a3.43,3.43,0,0,1,0-6.86H21a3.43,3.43,0,0,1,0,6.86Z"
          transform="translate(-0.05 -5.46)"
        />
      </svg>

      <div v-if="specialType === 'video'" class="vip-icon"></div>

      <div v-if="specialType === 'sceneEffect'" :class="figureClassName"></div>

      <img
        v-if="!specialType"
        :src="$handleAssetsUrl(info.thumbnailUrl)"
        alt=""
      />
    </div>
    <div class="detail">
      <div class="file-type">
        <div class="type-name">{{ displayType }}</div>
        <div v-if="info.removed" class="abandon-mark">已下架</div>
        <PayMark v-else :localType="localType" :item="getInfoForPrice()"></PayMark>
      </div>
      <div class="title">{{ this.getItemTitle() }}</div>
    </div>
    <div class="control" v-show="needAction">
      <div class="locate" @click="locate">
        <i></i>
      </div>
      <div class="remove" @click="locate({ isDel: true })">
        <i></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PayMark from "./priceTag.vue";
import getText from "./artwords";
// import a from '../../../../static/svg/copyright/copyright-membership';
export default {
  components: {
    PayMark,
  },
  props: {
    info: {
      type: Object,
      default() {
        return {
          fileType: "",
        };
      },
    },
    needAction: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      title: "",
      videoMax: 0,
      videoNum: 0,
      spriteType: "",
    };
  },
  computed: {
    ...mapGetters(["TOOL", "SelectScenes_Msg", "UserEquity", 'MaterialPane_Size']),
    ...mapGetters({
      musicArr: "addSoundtrack/getMusicArr",
      dubbingArr: "addSoundtrack/getDubbingArr",
    }),
    specialType() {
      let info = this.info;
      if (info.artword) {
        return "artword";
      } else if (info.type === "uploadVideoNUM") {
        return "video";
      } else if (info.type === 'sceneEffect') {
        return 'sceneEffect';
      }
      return "";
    },
    figureClassName() {
      if (this.info.type === 'sceneEffect') {
        return `icon-scene-effect icon-scene-slide-${this.info.effectType}`;
      }
      return ''
    },
    displayType () {
      return this.setFileType();
    },
    localType () {
      const m = {
        artword: 'artword',
        sceneEffect: 'sceneAnimation'
      }
      return m[this.specialType] || '';
    }
  },
  created() {
    this.setFileType(this.info);
    // this.$bus.on("riskDropShow", this.setFileType);
  },
  beforeDestroy() {
    this.$bus.off("riskDropShow", this.setFileType);
  },
  methods: {
    setFileType(info) {
      info = info || this.info;
      let val = info.fileType || info.type;
      if (info.specialType === 'artword') {
        val = 'Text';
      }
      let name = "";
      this.title = info.title;
      if (typeof val === "number") {
        switch (val) {
          case 1: // 静态素材-png,jpg等
          case 2: // 静态素材-svg
            name = "背景";
            break;
          case 3: // 静态素材-png,jpg等
          case 4: // svg
          case 5: // lottie
          case 22: // svg
          case 35: // 相框
          case 41: // 特效
          case 42: // 有声素材
          case 43: // 捏脸元素
          case 44: // 贴图-动态
            name = "道具";
            break;
          case 6: // 静态素材-png,jpg等
          case 7: // svg
          case 8: // lottie
          case 9: // 动态素材图表-json
          case 23: // svg
          case 29: // 可编辑颜色、线条粗细的svg
          case 33: // gif
            name = "形状";
            break;
          case 10: // lottie
            name = "角色";
            break;
          case 11: // 静态素材-png,jpg等
          case 12: // svg
          case 13: // json
          case 15: // 文字字体
          case 30: // 文字组合
            name = "文字";
            if (info.type === "RichText") {
              name = "富文本";
            }
            if (info.type === "groupSprites") {
              name = "组合元素";
            }
            break;
          case 32: // gif
            name = "GIF";
            break;
          case 14:
            this.spriteType = "sound";
            name = "音乐";
            if (info.type === "ScenesSound") {
              name = "场景音乐";
            }
            if (info.type === "sound" && info.id === "TOOLsound") {
              name = "背景音乐";
            }
            if (info.type === "sound" && info.id === "AllSound") {
              name = "全局录音";
            }
            break;
          case 24: //
            name = "场景";
            break;
          case 25:
          case 26:
            this.spriteType = "video";
            break;
        }
      } else {
        switch (val) {
          case "Chart":
            name = "图表";
            break;
          case "Image":
          case "Svg":
            name = "图片";
            break;
          case "Text":
            name = "文字";
            if (!info.fileType) {
              name = "艺术字";
            }
            break;
          case "RichText":
            name = "富文本";
            break;
          case "Lottie":
            name = "动画素材";
            break;
          case "uploadVideoNUM":
            this.handleVideoNum();
            name = "个人视频";
            break;
          case "sound":
            name = "音乐";
            break;
          case 'sceneEffect':
            name = '转场动画';
            break;
        }
      }
      this.fileType = name;
      return name;
    },
    handleVideoNum() {
      let info = this.info;
      let _vn = info.videoNum;
      let _dn = this.UserEquity.draftVideo;
      if (_vn > 3) {
        _dn = 3;
      }
      this.videoMax = _dn;
      this.videoNum = _vn;
      if (this.info.limitType === 'person') {
        _dn = 1;
      }
      this.title = "超过" + _dn + "个数量上限";
    },
    locate({ isDel = false } = {}) {
      if (this.info.type === "sound" && this.info.scenesId === "sound") {
        let slot = this.info.timeSlot;
        let index;
        this.musicArr.some((v, i) => {
          let flag =
            v.timeSlot[0] === slot[0] &&
            v.timeSlot[1] === slot[1] &&
            v.id === this.info.resourceId;
          if (flag) {
            index = i;
          }
          return flag;
        });
        if (isDel && index != null) {
          this.$store.commit("addSoundtrack/delMusic", index);
        }
        if (!isDel && index != null) {
          this.$store.commit("addSoundtrack/setSoundtrackState", {
            type: "bgm",
          });
          this.$store.commit("addSoundtrack/setMusicIndex", index);
          this.$bus.emit("openSubtitleLayer");
        }

        index = void 0;
        this.dubbingArr.some((v, i) => {
          let flag =
            v.timeSlot[0] === slot[0] &&
            v.timeSlot[1] === slot[1] &&
            v.id === this.info.resourceId;
          if (flag) {
            index = i;
          }
          return flag;
        });
        if (isDel && index != null) {
          this.$store.commit("addSoundtrack/delDubbing", index);
        }
        if (!isDel && index != null) {
          this.$store.commit("addSoundtrack/setSoundtrackState", {
            type: "dub",
          });
          this.$store.commit("addSoundtrack/setDubbingIndex", index);
          this.$bus.emit("openSubtitleLayer");
        }
        return;
      }
      if (
        this.info.scenesId === "TOOLsound" ||
        this.info.scenesId === "AllSound"
      ) {
        this.$bus.emit("FeaturesPop_vue", {
          name: "volume_adjust",
          posx: 0,
          posy: 0,
          type: 1,
        });
        if (isDel && this.info.scenesId === "TOOLsound") {
          this.TOOL.setSound({}, true);
        }
        if (isDel && this.info.scenesId === "AllSound") {
          this.TOOL.clearSoundRecord({ undo: true });
        }

        return;
      }
      if (this.info.type === "ScenesSound") {
        this.$bus.emit("FeaturesPop_vue", {
          name: "volume_adjust",
          posx: 0,
          posy: 0,
          type: 1,
        });
      }
      let scene = this.TOOL.getScenesIdData(this.info.scenesId);
      if (!scene) {
        scene = this.TOOL.sprites.find((v) => {
          return v.sprites.some((sprite) => {
            return sprite.id === this.info.id;
          });
        });
      }
      this.setSelectedScene(scene, { isDel });
    },
    setSelectedScene(data, { isDel = false } = {}) {
      if (this.SelectScenes_Msg.id !== data.id) {
        for (var k in this.SelectScenes_Msg.sprites) {
          //this.SelectScenes_Msg.sprites[k].effect.unInitActiveResource();
          if (this.SelectScenes_Msg.sprites[k].type == "Lottie") {
            this.SelectScenes_Msg.sprites[k].unActiveAnimation();
          }
        }
        // 切换
        this.TOOL.selectScenes(data).then(() => {
          if (data.fromJsonLoadingState < 1 && data.unLoadData.json) {
            let json = data.unLoadData.json;
            // if (isDel) {
            //   json.sprites = json.sprites.filter(v => v.type != 'Text');
            // }
            window.riskLocating = true;
            data
              .fromJson(
                json,
                this.TOOL.clientWidth / data.unLoadData.resolutionWidth,
                true
              )
              .then((scene) => {
                this.selectSprite({
                  isDel,
                  selectedScene: this.TOOL.selectedScenes,
                });
                if (this.info.type === "ScenesSound") {
                  this.$bus.emit("FeaturesPop_vue", {
                    name: "volume_adjust",
                    posx: 0,
                    posy: 0,
                    type: 1,
                  });
                }
              })
              .finally(() => {
                window.riskLocating = false;
              });
          } else {
            //场景页已经加载
            // this.$store.commit("open_FirstTemplateLoading");
            this.SelectScenes_Msg.activeAnimation()
              .then(() => {
                this.selectSprite({ isDel });
                if (this.info.type === "ScenesSound") {
                  this.$bus.emit("FeaturesPop_vue", {
                    name: "volume_adjust",
                    posx: 0,
                    posy: 0,
                    type: 1,
                  });
                }
              })
              .finally(() => {
                this.$store.commit("close_FirstTemplateLoading");
              });
          }
        });
      } else {
        this.selectSprite({ isDel });
      }
    },
    selectSprite({ isDel = false, selectedScene } = {}) {
      if (this.info.type === 'sceneEffect') {
        this.scrollSideList();
      }
      if (isDel && this.info.type === "scenes") {
        this.rmScene(this.info.id);
        return;
      }
      if (isDel && this.info.type === "bg") {
        this.rmBg(this.info.scenesId);
        return;
      }
      if (isDel && this.info.type === "ScenesSound") {
        this.rmSceneSound(this.info.scenesId);
        return;
      }
      if (isDel && this.info.type === 'sceneEffect') {
        this.rmSceneEffect(this.info.scenesId);
        return;
      }
      let sprite = this.TOOL.findSpriteById(this.info.id);
      let scene = this.TOOL.getScenesIdData(
        sprite ? sprite.scenesId : this.info.scenesId
      );
      let infoId = this.info.id;
      // if (selectedScene) {
      //   scene = selectedScene;
      //   sprite = selectedScene.sprites.find(v => v.id === this.info.id);
      //   if (this.info.type === 'Text') {
      //     sprite = selectedScene.sprites.find(v => v.type === this.info.type);
      //     infoId = sprite.id;
      //   }
      // }
      if (sprite && sprite.effect) {
        scene.nowTime = sprite.effect.exitAnim.start / 1000;
        this.TOOL.selectSprite([sprite]);
        eve("timeline_nowTime_change", null, {
          nowTime: sprite.effect.exitAnim.start / 1000,
        });
      }
      if (this.info.type === "groupSprites") {
        let data = this.info;
        let scenesData = this.TOOL.getScenesIdData(data.scenesId);
        let groupSprites = scenesData.getGroupData(data.id).sprites;
        let nowTime = 0;

        for (let c = 0; c < groupSprites.length; c++) {
          if (nowTime) {
            nowTime =
              groupSprites[c].effect.exitAnim.start / 1000 > nowTime
                ? nowTime
                : groupSprites[c].effect.exitAnim.start / 1000;
          } else {
            nowTime = groupSprites[c].effect.exitAnim.start / 1000;
          }
        }

        this.TOOL.selectSprite(groupSprites);
        eve("timeline_nowTime_change", null, { nowTime: nowTime });

        if (isDel) {
          for (let c = 0; c < groupSprites.length; c++) {
            this.TOOL.removeSprite(groupSprites[c].id, true);
          }
        }
      }
      if (isDel) {
        let s = this.TOOL.findSpriteById(infoId);
        if (s) {
          this.TOOL.removeSprite(infoId, true);
        }
        if (this.info.type === "Text") {
          // this.TOOL.removeSprite(infoId, true);
          // setTimeout(() => {
          //   this.TOOL.removeSprite(infoId, true);
          // }, 1600);
        } else {
          // let s = this.TOOL.findSpriteById(infoId);
          // if (s) {
          //   this.TOOL.removeSprite(infoId, true);
          // }
          // this.t_id = setInterval(() => {
          //   let s = this.TOOL.findSpriteById(infoId);
          //   if (s) {
          //     this.TOOL.removeSprite(infoId, true);
          //   } else {
          //     clearInterval(this.t_id);
          //   }
          // }, 100)
        }

        // this.$bus.emit('payPriceEvent_vue');
      }
      this.$bus.emit("riskItemLocate");
    },
    rmScene(id) {
      if (this.TOOL.sprites.length === 1) {
        this.TOOL.addScenes(null, null, true).then((scenes) => {
          this.TOOL.removeScenes(id);
          this.TOOL.selectScenes(scenes).then((data) => {
            // this.TOOL.moveScenesTo(scenes.id, scenesIndex);
          });
        });
      } else {
        this.TOOL.removeScenes(id);
        this.TOOL.selectScenes(this.TOOL.sprites[0]);
      }
    },
    rmBg(id) {
      let scenesData = this.TOOL.getScenesIdData(id);
      let bgOpts = {
        // 设置场景背景
        resourceId: null, // 背景资源id
        fileType: null, // 背景资源type
        type: "Color",
        data: {
          color: "#FFFFFF",
          blur: 0,
          opacity: 1,
        },
        zoomActive: false,
      };

      this.$store.commit("del_vipSprites", {
        id: "BG-" + scenesData.id,
      });
      scenesData.setBackground(bgOpts, null, true);
    },
    rmSceneSound(id) {
      const scenesData = this.TOOL.getScenesIdData(id);
      scenesData.clearSound();
    },
    rmSceneEffect (id) {
      const scenesData = this.TOOL.getScenesIdData(id);
      scenesData.updateEffect({code: 'None'}, true);
    },
    getItemTitle() {
      if (this.info.artword) {
        return getText(this.info.artword);
      }

      return this.title;
    },
    getInfoForPrice() {
      let payType = this.info.payType;
      if (this.specialType === "artword") {
        payType = 4;
      } else if (this.specialType === "video") {
        // payType = 4;
        const map = {
          person: 4,
          company: 6
        };
        payType = map[this.info.limitType];
      }

      return {
        ...this.info,
        payType,
      };
    },
    scrollSideList () {
      this.$bus.emit('materialPane_vue', {type: 'scenes'});
      $('#scenesDrag>div').each((i, v) => {
        const wrapperRect = $('.scenesArray')[0].getBoundingClientRect();
        const contentRect = $('#scenesDrag')[0].getBoundingClientRect();
        const rect = v.getBoundingClientRect();
        const match = $(v).data('id') === this.SelectScenes_Msg.id
        if (match) {
          // const ele = $('#scenesDrag>div').eq(i + 1).find('.scenes_animation');

          if (rect.top < wrapperRect.top || rect.bottom > wrapperRect.bottom) {
            // v.scrollIntoView();
            const scrollTop = rect.top - contentRect.top - 30;
            $('.scenesArray')[0].scrollTop = scrollTop;
            let scrollTimeout = null;
            $('.scenesArray').on('scroll', () => {
              clearTimeout(scrollTimeout);
              scrollTimeout = setTimeout(() => {
                // ele && ele.click();
                const rect = v.getBoundingClientRect();
                this.showPopup(rect.bottom - 105);
                $('.scenesArray').off('scroll');
              }, 100);
            });
          } else {
            // ele && ele.click();
            this.showPopup(rect.bottom - 105);
          }
        }
      });
    },
    showPopup (y) {
      this.$bus.emit("FeaturesPop_vue", {
        name: "sceneEffect",
        type: 1,
        initialX: this.MaterialPane_Size.width - 20,
        initialY: y,
        scenesMsg: {
          beforeEffect: this.SelectScenes_Msg,
          afterEffect: this.TOOL.sprites[this.SelectScenes_Msg.index + 1],
        },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.risk-item {
  display: flex;
  justify-content: left;
  align-items: center;
  width: 296px;
  height: 66px;
  padding: 0 14px;
  background: #fff;
  border-radius: 4px;
  .locate > i:hover {
    background-image: url(../../../assets/risk/locate-active.svg);
  }
  .remove > i:hover {
    background-image: url(../../../assets/risk/remove-active.svg);
  }
}
.figure {
  position: relative;
  overflow: hidden;
  width: 70px;
  height: 38px;
  background: #fafaff;
  // border: 1px solid #707070;
  border-radius: 4px;
  & > * {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 0;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
  & > *:not(.icon-scene-effect) {
    width: auto;
    height: auto;
  }
}
.detail {
  width: 118px;
  min-height: 36px;
  margin-right: 18px;
  margin-left: 9px;
  text-align: left;
  line-height: 20px;
  & .file-type {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }
  & .type-name {
    min-height: 16px;
    margin-right: 6px;
    font-size: 12px;
    font-weight: bold;
  }
  & .title {
    overflow: hidden;
    min-height: 16px;
    font-size: 12px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.control {
  display: flex;
  align-items: center;
  & .locate {
    cursor: pointer;
  }
  & .remove {
    cursor: pointer;
  }
}
.locate > i {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 16px;
  background-image: url(../../../assets/risk/locate.svg);
}
.remove > i {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(../../../assets/risk/remove.svg);
}

.vip-icon {
  width: 80%;
  height: 80%;
  background: no-repeat;
  background-image: url(../../../../static/svg/copyright/copyright-membership.svg);
  background-position: center center;
}
.abandon-mark {
  color: #f21616;
  font-family: Microsoft YaHei;
  font-size: 12px;
  font-weight: 400;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/riskDrop/riskItem.vue